export default {
    HEADER: 'Kategorija priloga/dodatka',
    PLACEHOLDER_NAME: 'Unesite naziv kategorije',
    LABEL_NAME: 'Naziv kategorije',
    LABEL_STATUS: 'Status',
    LABEL_MULTI_SELECT: 'Multi select',
    LABEL_MAX_SELECTION: 'Max selekcija',
    PLACEHOLDER_MAX_SELECTION: 'Dozvoljen broj',
    LABEL_UNLIMITED: 'Neograničeno',
    SAVE_BUTTON: 'Sačuvaj',
    CANCEL_BUTTON: 'Poništi',
};
